import { render } from "./WeddingKioskFormType1.vue?vue&type=template&id=011118d6&lang=true"
import script from "./WeddingKioskFormType1.vue?vue&type=script&lang=js"
export * from "./WeddingKioskFormType1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__